'use strict';

angular.module('amexReconciliationApp')
  .component('exportModal', {
    templateUrl: 'scripts/views/modals/export-modal.html',
    bindings: {
      closeModalCallback: '&',
      transactionIds: '<'
    },
    controller: function (TransactionSearchModel, UserPreferencesRepository, SiteConfigModel, UserModel, $element, $translate) {
      var self = this;

      self.$onInit = function () {
        self.closeModal = self.closeModalCallback;
        self.selectAll = true;
        self.preferredExportFields = _.cloneDeep(UserModel.currentUser().preferredExportFields);
        self.preferredExportFieldsForSite = _.find(self.preferredExportFields, ['siteNumber', SiteConfigModel.siteNumber()]);

        self.availableFields = SiteConfigModel.siteConfig().exportFields;

        self.availableFieldsState = buildAvailableFieldsState();
        self.fieldChanged();

        self.fieldOrderButtonsDisabled = true;
      };

      self.getBillingCycleDate = function () {
        return TransactionSearchModel.billingCycle().endDate;
      };

      self.getSelectedFieldNamesString = function () {
        return _.join(getSelectedFieldNames(), ',');
      };

      self.getSelectedFieldHeadersString = function () {
        var displayNames = [];
        _.forEach(_.filter(self.availableFieldsState, 'selected'), function(o) {displayNames.push(o.displayName);});
        return _.join(displayNames, ',');
      };

      self.isExportDisabled = function () {
        return self.selectedFieldNames.length === 0;
      };

      self.export = function () {

        $element.find('#export-form').submit();

        if (self.preferredExportFieldsForSite === undefined)
        {
          self.preferredExportFieldsForSite = {
            siteNumber: SiteConfigModel.siteNumber()
          };
          self.preferredExportFields.push(self.preferredExportFieldsForSite);
        }
        self.preferredExportFieldsForSite.fields = getSelectedFieldNames();

        var userPreferences = UserModel.currentUserPreferences();
        userPreferences.exportFields = self.preferredExportFields;

        UserPreferencesRepository.save(userPreferences)
          .then(function () {
            UserModel.currentUser().preferredExportFields = self.preferredExportFields;
            self.closeModal();
          });
      };

      self.selectAllChanged = function () {
        _.map(self.availableFieldsState, function (o) {
          o.selected = self.selectAll;
        });
        self.selectedFieldNames = self.getSelectedFieldNamesString();
        self.selectedFieldHeaders = self.getSelectedFieldHeadersString();
      };

      self.fieldChanged = function () {
        self.selectAll = _.every(self.availableFieldsState, 'selected');
        self.selectedFieldNames = self.getSelectedFieldNamesString();
        self.selectedFieldHeaders = self.getSelectedFieldHeadersString();
      };

      self.selectFieldToMove = function(fieldName) {
        _.map(self.fieldsToSort,function(o) {
          if (o.name == fieldName.name) {
            o['selectedToMove'] = true;
          } else {
            o['selectedToMove'] = false;
          }
        });
        self.fieldOrderButtonsDisabled = false;
      };

      self.openChangeOrder = function() {
        self.displayChangeOrder = true;
        self.fieldsToSort = getAvailableFieldsStateToSort();
      };

      self.closeChangeOrder = function() {
        _.map(self.fieldsToSort,function(o) { o['selectedToMove'] = false;} );
        self.displayChangeOrder = false;
        self.fieldOrderButtonsDisabled = true;
      };

      self.saveChangeOrder = function() {
        _.map(self.fieldsToSort,function(o) { o['selectedToMove'] = false;} );
        mergeSortedFieldsIntoAvailableFieldsState();
        self.displayChangeOrder = false;
        self.fieldOrderButtonsDisabled = true;
      };

      self.moveToTop = function() {
        moveField('toTop');
      };

      self.moveToBottom = function() {
        moveField('toBottom');
      };

      self.moveUp = function() {
        moveField('up');
      };

      self.moveDown = function() {
        moveField('down');
      };

      function mergeSortedFieldsIntoAvailableFieldsState() {
        var unselectedFields = _.filter(self.availableFieldsState, function(o) {return o.selected == false;});
        self.availableFieldsState = _.concat(self.fieldsToSort,unselectedFields);
        self.selectedFieldNames = self.getSelectedFieldNamesString();
        self.selectedFieldHeaders = self.getSelectedFieldHeadersString();
      }

      function getAvailableFieldsStateToSort() {
        return _.cloneDeep(_.filter(self.availableFieldsState,'selected'));
      }

      function moveField(moveMethod) {
        var index = _.findIndex(self.fieldsToSort, 'selectedToMove');
        if (index == -1) {return;}

        var movingField = _.cloneDeep(_.find(self.fieldsToSort, 'selectedToMove'));
        _.remove(self.fieldsToSort,'selectedToMove');

        switch (moveMethod) {
          case 'toTop':
            self.fieldsToSort.unshift(movingField);
            break;
          case 'toBottom':
            self.fieldsToSort.push(movingField);
            break;
          case 'up':
            if (index < 1) {
              self.fieldsToSort.unshift(movingField);
            } else {
              self.fieldsToSort.splice(index - 1, 0, movingField);
            }
            break;
          case 'down':
            self.fieldsToSort.splice(index + 1, 0, movingField);
            break;
        }
      }

      function buildAvailableFieldsState() {
        var fields = [];
        if (self.preferredExportFieldsForSite){
          fields = self.preferredExportFieldsForSite.fields;
        }

        var sortedAvailableFieldState = _.map(fields, function (fieldName) {
          return {
            name: fieldName,
            selected: isSelectedField(fieldName),
            displayName: getDisplayName(fieldName),
            selectedToMove: false
          };
        });

        _.forEach(self.availableFields, function (fieldName) {
          if (!_.includes(fields, fieldName)) {
            sortedAvailableFieldState.push(
              {
                name: fieldName,
                selected: isSelectedField(fieldName),
                displayName: getDisplayName(fieldName),
                selectedToMove: false
              }
            );
          }
        });
        return sortedAvailableFieldState;
      }

      function getDisplayName(fieldName) {
        var accountingFieldMatch = fieldName.match(/^export\.field\.AccountingField(\d+)$/);
        if (accountingFieldMatch) {
          var position = Number(accountingFieldMatch[1]);
          var accountingFieldSchemas = _.get(SiteConfigModel.siteConfig(), 'accountingFieldSchemas', []);
          return _.get(_.find(accountingFieldSchemas, ['position', position]), 'label');
        } else {
          var udfMatch = fieldName.match(/^export\.field\.UserDefinedField(\d+)$/);
          if(udfMatch) {
            var udfId = Number(udfMatch[1]);
            var userDefinedFields = _.get(SiteConfigModel.siteConfig(), 'userDefinedFields', []);
            return _.get(_.find(userDefinedFields, ['udfId', udfId]), 'label');
          } else {
            return $translate.instant(fieldName);
          }
        }
      }

      function  getSelectedFieldNames() {
        var names = [];
        _.forEach(_.filter(self.availableFieldsState, 'selected'),function(o) {names.push(o.name);});
        return names;
      }

      function isSelectedField(fieldName) {
        if (self.preferredExportFieldsForSite !== undefined) {
          return _.includes(self.preferredExportFieldsForSite.fields, fieldName);
        } else {
          return true;
        }
      }
    }
  });



//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/components/exportModal.js
// module id = 449
// module chunks = 0